<template>
  <div class="nav-top">
    <div class="logo" @click="goIndex" :style="{backgroundImage: 'url(' + logo + ')'}"></div>
    <ul class="r">
      <li><span @click="signUser">登录</span></li>
      <li><span @click="signUser">注册</span></li>
    </ul>
  </div>
</template>

<script>
  import SrNav from './nav'
  import SrQrCode from '@/components/QRCode'
  export default {
    components: {
      SrNav,
      SrQrCode
    },
    data () {
      return {
        logo: './static/img/logomin.png'
      }
    },
    methods: {
      goIndex () {
        this.$router.push('/index')
      },
      signUser () {
        this.$emit('click')
      }
    }
  }
</script>

<style lang="less" scoped>
  .nav-top {
    .logo, .r {
      position: absolute;
      top: 0;
      z-index: 3
    }
    .logo {
      left: 30px;
      width: 147px;
      height: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 31px;
      cursor: pointer;
    }
    .r {
      right: 30px;
      li {
        list-style: none;
        line-height: 50px;
        float: right;
        margin-left: 12px;
        span {
          color: #333;
          cursor: pointer;
          &:hover {
            color: #ccac66
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/nav-top.vue